var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElevatedStorageReservoir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6583 21.9063C42.6583 28.3124 41.0624 32.6208 34.7946 38.378C34.6773 38.4874 21.4844 49.7131 21.4844 49.7131C21.4844 49.7131 8.2363 38.2971 8.11895 38.1877C3.32597 33.973 0.318359 28.3124 0.318359 21.9063C0.318359 10.2126 9.79849 0.740234 21.4844 0.740234C33.1781 0.740234 42.6583 10.2126 42.6583 21.9063Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5642 38.6094C30.8763 38.6094 38.4253 31.0604 38.4253 21.7483C38.4253 12.4362 30.8763 4.88721 21.5642 4.88721C12.2521 4.88721 4.70312 12.4362 4.70312 21.7483C4.70312 31.0604 12.2521 38.6094 21.5642 38.6094Z",
    fill: "#3b9fbd",
    stroke: "#158AD1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1514 11.9423C22.5999 8.96028 17.2624 10.8176 14.8594 11.9869C14.0422 12.3846 13.5312 13.22 13.5312 14.1289V30.1951H29.4439V14.0682C29.4439 13.1745 28.9387 12.3652 28.1514 11.9423ZM24.5212 25.1301C23.7073 25.9307 22.7219 26.3311 21.5642 26.3311C20.407 26.3311 19.4211 25.9307 18.6077 25.1301C17.7937 24.3294 17.387 23.3547 17.387 22.2059C17.387 21.6577 17.4934 21.1333 17.7068 20.6329C17.9199 20.1324 18.2224 19.6908 18.614 19.3079L21.5642 16.4098L24.5147 19.3079C24.9063 19.6908 25.2087 20.1324 25.4219 20.6329C25.635 21.1333 25.7417 21.6577 25.7417 22.2059C25.7417 23.3547 25.3347 24.3294 24.5212 25.1301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.318359 0.740234)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatedStorageReservoir);
export default __webpack_public_path__ + "static/media/elevated-storage-reservoir.e9e366d7c25f0fb61ac03b04b7428ce5.svg";
export { ForwardRef as ReactComponent };